"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        /**
         * Cached context of Navigation Bar
         */
        ui._cachedNavBar = null;
        function getNavBar() {
            if (!$dyn.ui._cachedNavBar) {
                $dyn.ui._cachedNavBar = $dyn.context(document.body.querySelector(".navigationBar"));
            }
            return $dyn.ui._cachedNavBar;
        }
        ui.getNavBar = getNavBar;
        /**
         * Cached context of MessageCenter
         */
        ui._cachedMessageCenter = null;
        function getMessageCenter() {
            if (!$dyn.ui._cachedNavBar) {
                $dyn.ui._cachedMessageCenter = $dyn.context(document.body.querySelector(".navigationBar-messageControl"));
            }
            return $dyn.ui._cachedMessageCenter;
        }
        ui.getMessageCenter = getMessageCenter;
    })(ui = $dyn.ui || ($dyn.ui = {}));
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                DefaultCaption: "Form",
                MessageCenter_MessageCount: "{0} total",
                NavBar_About: "About",
                NavBar_ChangePreferences: "Options",
                NavBar_Close: "Close",
                NavBar_D365PortalUrl: "https://home.dynamics.com",
                NavBar_Feedback: "Feedback",
                NavBar_GoToD365Fallback: "Go to the Dynamics 365 portal",
                NavBar_GoToDashboard: "Go to dashboard (Alt+Shift+Home)",
                NavBar_Help: "Help",
                NavBar_HelpHelpText: "(Ctrl+?)",
                NavBar_HelpLegal: "Legal",
                NavBar_HelpMenu: "Help & support",
                NavBar_HelpPrivacy: "Privacy and cookies",
                NavBar_Landmark: "Navigation bar",
                NavBar_LegalUrl: "http://go.microsoft.com/fwlink/?LinkID=290927",
                NavBar_MessageReceived: "{0} ago",
                NavBar_OfficePortalUrl: "https://www.office.com",
                NavBar_OfficeWaffle: "Office 365",
                NavBar_OfficeWaffleHelpText: "Go to the Office 365 site",
                NavBar_OfficeWaffleHelpTextFallback: "Go to the Office 365 portal",
                NavBar_Overflow: "More",
                NavBar_PrivacyUrl: "http://go.microsoft.com/fwlink/?LinkID=271135",
                NavBar_RegionTitle: "Navigation Bar Region",
                NavBar_Settings: "Settings",
                NavBar_ShowNotifications: "Show messages",
                NavBar_ShowNotificationsHelpText: "(Ctrl+Shift+F7)",
                NavBar_Support: "Support",
                NavBar_SupportHelpText: "Contact support",
                NoCaptionProvidedError: "No caption found for form, using default caption.",
            },
        });
        /**
         * Manages access to the controls that are available application wide.
         */
        var NavigationBar = /** @class */ (function (_super) {
            __extends(NavigationBar, _super);
            function NavigationBar(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.navigationBarElement = null;
                _this.menuPaneOpenerInNavBar = false;
                _this.UserSettingsVisible = $dyn.observable(false);
                _this.Crumbs = $dyn.observableArray([]);
                _this.OfficeNavBarVisible = $dyn.observable(false);
                _this.IsFormPersonalizable = $dyn.observable(false);
                // add tab contanier
                _this.tabbingContainerDispose = $dyn.util.tabbingContainer(element, $dyn.label("NavBar_RegionTitle"));
                // Method(s) that gets overridden in html-binding-telemetry
                _this.recordUserSettingsTelemetry = function () { };
                _this.recordTelemetry = function () { };
                $dyn.observe(_this.OfficeNavBarVisible, function (visible) {
                    _this.setNavBarVisual(visible);
                });
                $dyn.observe(_this.UserSettingsVisible, function (visible) {
                    if (visible) {
                        // add handler for navigation
                        $(document.body).on("resetShellOnNavigation.dynNavigationBarSettings", function () {
                            _this.UserSettingsVisible(false);
                        });
                        _this.recordUserSettingsTelemetry();
                    }
                    else {
                        $(document.body).off("resetShellOnNavigation.dynNavigationBarSettings");
                    }
                });
                _this.NavigateToNotificationsForm = function () {
                    _this._navBarMenuNavigate($dyn.controls.NavigationBar.ActionCenterFormName, "Display");
                };
                // Task: #1493552 - Remove workaround for $dyn.serverForm should being in retail builds for control gallery because of script combining.
                // currently these array's are declared in $dyn.serverForm, if serverForm is not present lets not break
                if (!$dyn.controls.NavigationBar.actions) {
                    $dyn.controls.NavigationBar.actions = [];
                }
                _this.actions = $dyn.observableArray($dyn.controls.NavigationBar.actions);
                if (!$dyn.controls.NavigationBar.settingsMenu) {
                    $dyn.controls.NavigationBar.settingsMenu = [];
                }
                _this.settingsMenu = $dyn.observableArray($dyn.controls.NavigationBar.settingsMenu);
                _this.helpMenu = $dyn.observableArray($dyn.controls.NavigationBar.helpMenu);
                // Overflow story: As viewport width decreases, first the CSS will reduce the width of some elements.
                // After the CSS adjustments are finished, the next step is to add unpinned buttons into an overflow menu.
                _this.ShowOverflowButton = $dyn.computed(function () {
                    return $dyn.length(_this.overflowMenu) > 0;
                });
                _this.overflowMenu = $dyn.observableArray([]);
                // flyout handler expects a jquery object.
                _this.overFlowButton = element ? $(element.getElementsByClassName("navigationBar-overflowButton")[0]) : undefined;
                _this._viewportChangeHandler(null, $dyn.shell.CurrentShellViewPortWidthSize);
                _this.viewportBindingHandler = $dyn.bindingHandlers.ShellViewportWidthSize();
                _this.viewportBindingHandler.apply(_this._viewportChangeHandler, _this);
                return _this;
            }
            NavigationBar.controlName = function (prefix, name) {
                var uniqueName = "NavBar_" + $dyn.controls.NavigationBar.controlIndex + prefix + name;
                $dyn.controls.NavigationBar.controlIndex++;
                return uniqueName;
            };
            NavigationBar.prototype.clearCrumb = function () {
                if ($dyn.length(this.Crumbs) > 0) {
                    this.Crumbs.clear();
                }
            };
            NavigationBar.prototype.navigateToDashboard = function () {
                $dyn.shell.closeAllFormsBeforeNavigating($dyn.shell.goHome);
            };
            /**
             * This is a function that will request the help and settings menu from the AOS and populate them
             */
            NavigationBar.prototype.loadNavMenus = function () {
                // build settings menu
                this._getNavMenu("SysMenuSettings", this.settingsMenu);
                // add custom items only to sysMenuSettings
                this._addCustomNavMenuItems(this.settingsMenu);
            };
            /**
             * This is a function that will request a passed in menu and store in a passed in list.
             * @internal
             * @param menuName Menu to read from server.
             * @param navMenu List to store the menu in.
             */
            NavigationBar.prototype._getNavMenu = function (menuName, navMenu) {
                var _this = this;
                $dyn.async(function () {
                    $dyn.DynReact.ModuleStore._requestMenuStructure("RetrieveSitemapMenu", function (result) {
                        var e_1, _a;
                        var parsedStructure;
                        if (result) {
                            if (!$.isPlainObject(result)) {
                                // Result descriptor had an incorrect value type.
                                parsedStructure = JSON.parse(result);
                            }
                            else {
                                parsedStructure = result;
                            }
                            if (parsedStructure && parsedStructure.GetDataContract) {
                                var foundMenuItem = false;
                                var _loop_1 = function (item) {
                                    // we only support MenuItems
                                    if (item.getMenuItemType && !item.getTileName) {
                                        navMenu.push({
                                            Click: function () {
                                                _this._navBarMenuNavigate(item.getMenuItemName, item.getMenuItemType);
                                            },
                                            HelpText: item.getHelpTextStr,
                                            Label: item.getTitleStr,
                                            MenuItem: item.getMenuItemName,
                                            MenuItemType: item.getMenuItemType,
                                            Name: item.getFormName,
                                            Visible: _this._navMenuItemVisible(item.getMenuItemName),
                                        });
                                        if (navMenu()[navMenu().length - 1].Visible) {
                                            foundMenuItem = true;
                                        }
                                    }
                                };
                                try {
                                    for (var _b = __values(parsedStructure.GetDataContract), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var item = _c.value;
                                        _loop_1(item);
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                // perform hide if empty logic
                                if (!foundMenuItem) {
                                    var elementName = parsedStructure.getName === "SysMenuSettings" ? "navigationBar-settingsButton" : "navigationBar-helpButton";
                                    var element = document.getElementsByClassName(elementName)[0];
                                    element.style.display = "none";
                                }
                            }
                        }
                    }, { menuItem: menuName });
                });
            };
            NavigationBar.prototype.dispose = function () {
                if (this.tabbingContainerDispose) {
                    this.tabbingContainerDispose();
                }
                if (this.viewportBindingHandler && this.viewportBindingHandler.dispose) {
                    this.viewportBindingHandler.dispose();
                }
                $dyn.ui._cachedNavBar = null;
                this.navigationBarElement = null;
                this.overFlowButton = null;
                this.menuPaneOpenerElement = null;
                _super.prototype.dispose.call(this);
            };
            NavigationBar.prototype.setNavBarVisual = function (officeLook) {
                var officeNavBar = "officeNavBar";
                var navBar = $dyn.ui.getNavBar();
                if (navBar) {
                    if (officeLook) {
                        navBar.element.classList.add(officeNavBar);
                        var navSearch = $dyn.context($("#NavigationSearch")[0]);
                        navSearch.SearchFieldVisible(true);
                        navBar.helpMenu.push({
                            ButtonDisplay: $dyn.ui.ButtonDisplay.imageOnly,
                            Click: function () { $dyn.ui.feedBack(); },
                            HelpText: $dyn.label("NavBar_FeedbackHelpText"),
                            ImageName: "Smiley",
                            ImageType: "Symbol",
                            Label: $dyn.label("NavBar_Feedback"),
                            Name: "navBarFeedback",
                        });
                        // move search
                        $("#NavigationSearch").insertBefore("#navigationMainActionGroup");
                    }
                    else {
                        navBar.element.classList.remove(officeNavBar);
                        var navSearch = $dyn.context($("#NavigationSearch")[0]);
                        navSearch.SearchFieldVisible(false);
                        navBar.settingsMenu.pop();
                        $("#NavigationSearch").insertAfter("#Company");
                    }
                }
            };
            /**
             * Hide all unpinned buttons in the NavBar and add MenuItems for them in the Overflow menu.
             */
            NavigationBar.prototype._moveButtonsToOverflow = function () {
                var _this = this;
                var buttons = [];
                var candidates = Array.from(this.element.querySelector("#coreNavActions").children);
                // we move all buttons in a single move, thus we can check if any exist in overflow and skip this code
                if ($dyn.length(this.overflowMenu) === 0) {
                    candidates.forEach(function (element) {
                        if (element && element.offsetHeight > 0 && !element.classList.contains("navigationBar-pinnedElement")) {
                            if (_this._validButtonForOverflow(element)) {
                                buttons.push(element);
                            }
                            else {
                                if (element.classList.contains("navigationBar-list")) {
                                    // expand the list to get any contained buttons.
                                    var elementChildren = Array.from(element.children);
                                    elementChildren.forEach(function (elementChild) {
                                        // button is inside a <li>, so check the child.
                                        if (elementChild.children[0] &&
                                            elementChild.children[0].offsetHeight > 0 &&
                                            _this._validButtonForOverflow(elementChild.children[0])) {
                                            buttons.push(elementChild.children[0]);
                                        }
                                    });
                                }
                                else {
                                    // Check for specialized buttons like UserButton
                                    if (element.children[0] && _this._validButtonForOverflow(element.children[0])) {
                                        buttons.push(element.children[0]);
                                    }
                                }
                            }
                        }
                    });
                    // special case - move the office waffle if it exists
                    var waffleBtn = document.body.querySelector(".navigationBar-officeWaffle");
                    if (waffleBtn) {
                        buttons.push(waffleBtn);
                    }
                    buttons.forEach(function (buttonElement) {
                        var click;
                        var button = $dyn.context(buttonElement);
                        buttonElement.style.display = "none";
                        if (button instanceof $dyn.controls.MenuButton) {
                            button.currentAnchor = _this.overFlowButton;
                            click = function () {
                                button.ShowFlyout(true);
                            };
                        }
                        else {
                            click = button.Click;
                        }
                        _this.overflowMenu.unshift({
                            Click: click,
                            hiddenElement: buttonElement,
                            Label: buttonElement.title || button.Title || button.Label,
                            Name: button.Name,
                        });
                    });
                }
            };
            /**
             * Removes each MenuItem from the overflow MenuButton and shows the corresponding NavBar button.
             */
            NavigationBar.prototype._removeButtonsFromOverflow = function () {
                var hiddenElement;
                while ($dyn.length(this.overflowMenu) > 0) {
                    hiddenElement = this.overflowMenu.pop().hiddenElement;
                    hiddenElement.style.display = "";
                    var hiddenContext = $dyn.context(hiddenElement);
                    if (hiddenContext instanceof $dyn.controls.MenuButton) {
                        hiddenContext.currentAnchor = null;
                    }
                }
            };
            /**
             * Responsive viewport handler to set the initial arrangement and react to viewport changes.
             * @param event The event that tiggered the viewport size change.
             * @param currentViewportWidthSize The new viewport size.
             */
            NavigationBar.prototype._viewportChangeHandler = function (event, currentViewportWidthSize) {
                var showSearchOnOfficeHeader;
                // get the navigation bar selector if null
                if (this.navigationBarElement == null) {
                    this.navigationBarElement = document.body.querySelector(".navigationBar");
                }
                // for navigation bar sizing we must remove asidepane size if it is open
                var asidePaneSize = $dyn.value($dyn.shell.isAsidePaneOpen) ? $dyn.shell.CurrentViewportSizes.viewportWidth : 0;
                // handle specific classes for responsive layout and button overflow
                if (currentViewportWidthSize != null && this.navigationBarElement != null) {
                    // handle overflow checks navigation bar buttons
                    if (currentViewportWidthSize <= ($dyn.shell.NavBarSizes.largeNavBarSize + asidePaneSize)) {
                        this._moveButtonsToOverflow();
                    }
                    else {
                        this._removeButtonsFromOverflow();
                    }
                    // start checking for smallest view port to larger for responsive changes
                    // handle extra small view port sizing changes
                    // first clear all sizing classes
                    $(this.navigationBarElement).removeClass("navBarXSmall navBarSmall navBarMedium navBarLarge");
                    showSearchOnOfficeHeader = false;
                    if (currentViewportWidthSize <= ($dyn.shell.NavBarSizes.xsmallNavBarSize + asidePaneSize)) {
                        $(this.navigationBarElement).addClass("navBarXSmall");
                    }
                    else {
                        // handle small view port sizing changes
                        if (currentViewportWidthSize <= ($dyn.shell.NavBarSizes.smallNavBarSize + asidePaneSize)) {
                            $(this.navigationBarElement).addClass("navBarSmall");
                        }
                        else {
                            // handle medium view port sizing changes
                            if (currentViewportWidthSize <= ($dyn.shell.NavBarSizes.mediumNavBarSize + asidePaneSize)) {
                                $(this.navigationBarElement).addClass("navBarMedium");
                            }
                            else {
                                showSearchOnOfficeHeader = true;
                                // handle large view port sizing changes
                                if (currentViewportWidthSize <= ($dyn.shell.NavBarSizes.largeNavBarSize + asidePaneSize)) {
                                    $(this.navigationBarElement).addClass("navBarLarge");
                                }
                            }
                        }
                    }
                    if (!$dyn.restrictedNavigation && this.OfficeNavBarVisible()) {
                        var navSearch = $dyn.context($("#NavigationSearch")[0]);
                        if (navSearch) {
                            if (showSearchOnOfficeHeader) {
                                navSearch.SearchFieldVisible(true);
                                navSearch.SearchFieldAlwaysOpen(true);
                            }
                            else {
                                navSearch.SearchFieldVisible(false);
                                navSearch.SearchFieldAlwaysOpen(false);
                            }
                        }
                    }
                    this._checkMenuPaneOpener(currentViewportWidthSize, asidePaneSize);
                }
            };
            /**
             * Check if we need to menu opener from the gutter to nav pane.
             * @param currentViewportWidthSize The new viewport size.
             * @param asidePaneSize asidepane size.
             */
            NavigationBar.prototype._checkMenuPaneOpener = function (currentViewportWidthSize, asidePaneSize) {
                // make sure we have navigation enabled
                if (!$dyn.restrictedNavigation && !$dyn.shell._noNavigationPane) {
                    // if not already cached, build the menupane button
                    if (this.menuPaneOpenerElement === undefined || this.menuPaneOpenerElement === null) {
                        this.menuPaneOpenerElement = document.createElement("Button");
                        this.menuPaneOpenerElement.setAttribute("data-dyn-role", "SymbolButton");
                        this.menuPaneOpenerElement.id = "NavBarMenuPaneOpener";
                        this.menuPaneOpenerElement.dynOptions = {
                            ariaExpanded: false,
                            attr: { "data-dyn-expanded": false },
                            ButtonDisplay: "BackgroundImage",
                            Click: function () {
                                $dyn.shell.setNavigationPaneIsOpen(true);
                            },
                            css: { "navBar-separator": !$dyn.value($dyn.ui.getNavBar().OfficeNavBarVisible()) },
                            HelpText: $dyn.label("NavBar_ShowNavigationPaneHelpText"),
                            ImageName: "NavigationPane",
                            ImageType: "Symbol",
                            Label: $dyn.label("NavigationPane_ExpandToolTip"),
                            Name: "NavBarMenuPaneOpener",
                        };
                        this.menuPaneOpenerElement.classList.add("navigationBar-button");
                        this.menuPaneOpenerElement.classList.add("navigationBar-modulesPaneOpener");
                        this.menuPaneOpenerElement.classList.add("button");
                        this.menuPaneOpenerElement.classList.add("dynamicsButton");
                    }
                    if (currentViewportWidthSize <= ($dyn.shell.NavBarSizes.smallNavBarSize + asidePaneSize)) {
                        if (!this.menuPaneOpenerInNavBar) {
                            // get the navbar launch region
                            var navLaunchRegion = $(this.navigationBarElement).find(".navigationBar-launch")[0];
                            if (navLaunchRegion) {
                                navLaunchRegion.insertBefore(this.menuPaneOpenerElement, null);
                                $dyn.dataBind(this.menuPaneOpenerElement);
                                // rerender navigation dom
                                $dyn.shell._renderNavigationPane();
                                this.menuPaneOpenerInNavBar = true;
                            }
                        }
                    }
                    else {
                        if (this.menuPaneOpenerInNavBar) {
                            var menuPaneOpener = $(this.navigationBarElement).find(".navigationBar-modulesPaneOpener")[0];
                            if (menuPaneOpener) {
                                // remove the navbarmenuopener
                                menuPaneOpener.parentNode.removeChild(menuPaneOpener);
                                // rerender nav pane
                                $dyn.shell._renderNavigationPane();
                                this.menuPaneOpenerInNavBar = false;
                            }
                        }
                    }
                }
            };
            /**
             * Validate if a particular element is a button that can be put in the overflow menu.
             * @param element A candidate dom element.
             * @returns true if the element is a type to consider for overflow.
             */
            NavigationBar.prototype._validButtonForOverflow = function (element) {
                var role = element.getAttribute("data-dyn-role");
                var returnVal = false;
                if (!$dyn.restrictedNavigation &&
                    (element.id === "UserBtn") &&
                    (role === "UserButton" || role === "UserMenuButton" || element.tagName === "BUTTON")) {
                    returnVal = false;
                }
                else if (role === "Button" ||
                    role === "MenuButton" ||
                    element.tagName === "BUTTON") {
                    returnVal = true;
                }
                return returnVal;
            };
            /**
             * This is a function will add a custom client side only menu item
             * @param menuList menu list to add to.
             */
            NavigationBar.prototype._addCustomNavMenuItems = function (menuList) {
                menuList.push({
                    Click: function () {
                        if (!$dyn.evaLoaded && !$dyn.evaLoading) {
                            $dyn.evaLoading = true;
                            // load eva from resources
                            $dyn.requireResourceBundle("/resources/html/EvaWebComponent", function () {
                                $dyn.evaLoading = false;
                                $dyn.evaLoaded = true;
                                $dyn.ax.Eva.ui.open();
                            });
                        }
                        else if ($dyn.evaLoaded) {
                            $dyn.ax.Eva.ui.open();
                        }
                    },
                    Label: $dyn.label("Shell_OpenEvaPane"),
                    Name: "Eva_OpenPane",
                    Visible: ($dyn.debug.cortana === true),
                });
            };
            /**
             * This will determine if a menu element should be visible based on client side logic
             * @param menuItem menuItem to look into for visibility
             * @returns true if the element is visible.
             */
            NavigationBar.prototype._navMenuItemVisible = function (menuItem) {
                switch (menuItem) {
                    case "SysTaskRecorderPane":
                        if ($dyn.debug.cortana !== true) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    case "SysTracingPane":
                        return $dyn.computed(function () { return !$dyn.ax._tracing.paneIsOpen(); });
                    case "SysPersonalize":
                        return this.IsFormPersonalizable;
                    case "SysHelpPane":
                    case "OpenSupportForm":
                    case "OpenIdeasLink":
                        return $dyn.computed(function () { return !$dyn.shell.hasRestrictedInternet(); });
                    default:
                        return true;
                }
            };
            /**
             * generic navigate function that handles navpane navigation
             */
            NavigationBar.prototype._navBarMenuNavigate = function (menuItem, menuItemType) {
                switch (menuItem) {
                    case "SysHelpPane":
                        $dyn.shell.openHelpPane();
                        break;
                    case "SysTaskRecorderPane":
                        $dyn.ax.taskRecording.open();
                        break;
                    case "SysAppDesignerPane":
                        $dyn.ax.appDesigner.open();
                        break;
                    case "SysTracingPane":
                        $dyn.ax._tracing.open();
                        break;
                    case "SysPersonalize":
                        $dyn.context($dyn.shell.getActiveForm()).personalize();
                        break;
                    default:
                        $dyn.shell.createForm({ menuItem: menuItemType + ":" + menuItem, elementCreated: $dyn.serverForm.getForm });
                }
            };
            NavigationBar.ActionCenterFormName = "SystemNotification";
            NavigationBar.controlIndex = 1;
            return NavigationBar;
        }($dyn.ui.Control));
        controls.NavigationBar = NavigationBar;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=NavigationBar.js.map
